import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AgentDeletedNoticeProps {
  /** The agent still exists, but the caller may not open it. */
  isAccessDenied?: boolean;
  /** Named in the access copy once its profile has loaded. */
  agentName?: string;
}

export const AgentDeletedNotice = ({
  isAccessDenied = false,
  agentName,
}: AgentDeletedNoticeProps) => {
  const { t } = useTranslation('chats');

  let message: string = t('chats.agentDeletedNotice.thisToolIsNoLonger');
  if (isAccessDenied) {
    message = agentName
      ? t('chats.agentDeletedNotice.noAccess', { agentName })
      : t('chats.agentDeletedNotice.noAccessThisAgent');
  }

  return (
    <div
      data-testid="agent-deleted-notice"
      className="flex items-center gap-3 rounded-lg bg-warning px-4 py-3"
    >
      <InfoIcon
        data-testid="agent-deleted-notice-icon"
        aria-hidden
        className="size-5 shrink-0 text-warning-foreground"
      />
      <p className="text-sm leading-5 text-muted-foreground">{message}</p>
    </div>
  );
};
